import React from 'react';
// @ts-expect-error TS(2305): Module '"prop-types"' has no exported member 'Prop... Remove this comment to see the full error message
import { PropTypes } from 'prop-types';

import { mui } from '~/tools/mui';
import { icons } from '~/tools/icons';
import { useTranslation } from '~/behaviors';
import Button from '~/components/Button';

const VisibilityAdornment = ({ inputType = 'password', onClick = (f) => f }) => {
  // @ts-expect-error TS(2339): Property 'propTypes' does not exist on type '({ in... Remove this comment to see the full error message
  VisibilityAdornment.propTypes = {
    inputType: PropTypes.oneOf(['password', 'text']),
    onClick: PropTypes.func,
  };

  const { t } = useTranslation();

  return (
    <mui.InputAdornment position="end">
      <Button
        aria-label="toggle password visibility"
        onClick={onClick}
        size="small"
        color="grey"
        data-testid="password-visibility-toggle"
        startIcon={inputType === 'password' ? <icons.Visibility /> : <icons.VisibilityOff />}
      >
        {/*
          // @ts-expect-error TS(2322): Type 'TFunctionResult' is not assignable to type '... Remove this comment to see the full error message */}
        {t(inputType === 'password' ? 'show' : 'hide')}
      </Button>
    </mui.InputAdornment>
  );
};

export default VisibilityAdornment;
